import { render, staticRenderFns } from "./SkeletonProductList.vue?vue&type=template&id=c27fa94c&scoped=true&"
import script from "./SkeletonProductList.vue?vue&type=script&lang=js&"
export * from "./SkeletonProductList.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonProductList.vue?vue&type=style&index=0&id=c27fa94c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27fa94c",
  null
  
)

export default component.exports